import { render } from "./plays-content.vue?vue&type=template&id=4975f192&ts=true"
import script from "./plays-content.vue?vue&type=script&lang=ts"
export * from "./plays-content.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Queries/plays-content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4975f192"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4975f192', __exports__)) {
    api.reload('4975f192', __exports__)
  }
  
  module.hot.accept("./plays-content.vue?vue&type=template&id=4975f192&ts=true", () => {
    api.rerender('4975f192', render)
  })

}


export default __exports__